import infrastructureresillience from "../../../assets/images/infrastructureresillience.png";
import naturebasedsolutions from "../../../assets/images/naturebasedsolutions.png";
import communityresillience from "../../../assets/images/communityresillience.png";
import riskmanagement from "../../../assets/images/riskmanagement.png";

export const CarouselData = [
  {
    id: 1,
    title: "Infrastructure Resilience",
    image: infrastructureresillience,
    description:
      "Develops robust physical and technical infrastructure to withstand and mitigate climate risks, including floods, heat, and sea-level rise.",
    funding: [
      "Public-Private Partnerships (PPPs)",
      "Sovereign and municipal green bonds",
      "Multilateral loans",
      "Infrastructure-specific grants",
    ],
    projects: 16,
    budget: "~$7 BILLION",
    projectList: [
      "Flood prevention and clean energy via waste collection and incineration",
      "Targeted wastewater treatment to prevent flood-contaminated drinking water",
      "Clean drinking water source in areas with failing groundwater supply",
      "Resilient road and transit links in inundated areas",
      "Protecting inundated power and communications infrastructure",
      "Rainwater harvesting on commercial buildings to reduce extreme rainfall-related flooding",
      "Resilient water links for Lagos inner-city connections",
      "Strengthened sea defenses to reinforce existing coastal embankment",
      "Inner-city flood prevention through new primary drainage systems",
      "Inner-city flood prevention through new and rehabilitated secondary drainage systems",
      "Flood-enhanced inner-city roads across 10 vulnerable governmental areas",
      "Retrofitted pavements of 1,800km for extreme heat mitigation",
      "Expanded stormwater channels for enhanced flood management",
      "Protective artificial flood barriers for climate-resilient community areas",
    ],
    link: "/Project/Infrastructure Resilience",
  },
  {
    id: 2,
    title: "Nature-Based Solutions",
    image: naturebasedsolutions,
    description:
      "Leverages ecosystems to address climate challenges, enhancing environmental and community resilience.",
    funding: [
      "Grants from biodiversity and climate-focused funds",
      "Carbon credits financing",
      "Bilateral aid",
      "Debt-for-nature swaps",
    ],
    projects: 5,
    budget: "~$150 MILLION",
    projectList: [
      "Inland flood prevention through mangrove restoration across Lagos",
      "Water-resilient agriculture and agroforestry",
      "Planting of climate-resilient trees across Lagos",
      "Rehabilitate and maintenance of existing urban parks",
      "Nature-based inland flood solutions",
    ],
    link: "/Project/Nature-Based Solutions",
  },
  {
    id: 3,
    title: "Community Resilience & Health",
    image: communityresillience,
    description:
      "Focuses on safeguarding vulnerable populations, improving health systems, and ensuring equitable climate adaptation.",
    funding: [
      "Social impact bonds",
      "Impact investment funds",
      "Grants from health and social welfare-focused organizations",
      "Bilateral and multilateral funding partnerships",
    ],
    projects: 9,
    budget: "~$1 BILLION",
    projectList: [
      "Implement surveillance systems for climate change-related existing and new diseases",
      "Relocating permanently displaced populations to climate responsive housing",
      "Resilient aquafarming facilities designed to minimize yield losses caused by flooding",
      "Heat-alleviating adaptation of social infrastructures",
      "Flood and heat-retrofit of schools and health centers",
      "Safe relocation and empowerment for vulnerable populations",
      "Medical infrastructure blueprint alleviating climate risk-related healthcare demand",
      "Digitalization to enable a climate-resilient healthcare system",
      "Health insurance access for vulnerable communities in exposed governmental areas",
    ],
    link: "/Project/Community Resilience & Health",
  },
  {
    id: 4,
    title: "Risk Management & Early Warning",
    image: riskmanagement,
    description:
      "Enhances Lagos’ capacity to anticipate and respond to climate emergencies through technology and preparedness.",
    funding: [
      "Multilateral disaster risk financing",
      "Concessional loans",
      "Parametric insurance schemes",
      "Technical assistance grants",
    ],
    projects: 4,
    budget: "~$1 BILLION",
    projectList: [
      "Early warning system for extreme weather events",
      "Heat-reducing redesign of governmental area structures",
      "Active water management with flood-resilient pumping stations",
      "Creation of Lagos adaptation emergency response fund",
    ],
    link: "/Project/Risk Management & Early Warning",
  },
];
